import { supabase } from '@/src/core/config/supabase';
import { logger } from '@/src/core/utils';

export class DeleteAccountUseCase {
  async execute(userId: string, avatarUrl?: string): Promise<void> {
    logger.info('DeleteAccount', 'Starting account deletion', { userId });

    // Best-effort: delete avatar from storage before removing the auth record
    if (avatarUrl) {
      try {
        const parts = avatarUrl.split('/avatars/');
        if (parts[1]) {
          const fileName = parts[1].split('?')[0];
          await supabase.storage.from('avatars').remove([fileName]);
        }
      } catch (storageError) {
        logger.warn('DeleteAccount', 'Could not delete avatar, continuing', { storageError });
      }
    }

    // Delete auth user — ON DELETE CASCADE handles all related DB rows
    const { error } = await supabase.rpc('delete_account');
    if (error) {
      logger.error('DeleteAccount', 'Failed to delete account', { error });
      throw error;
    }

    logger.info('DeleteAccount', 'Account deleted successfully', { userId });
  }
}
